import type { Pipeline } from "@/schema"

import type { AutomationSubjectType, FrontendTriggerDefinition, TriggerConfig } from "../../types"

export function resolveTriggerProvidedSubjects(
  definition: FrontendTriggerDefinition,
  trigger?: TriggerConfig,
  pipelines?: Pipeline[]
): AutomationSubjectType[] {
  const subjects = new Set(definition.providesSubjects ?? [])
  const inputValues = new Map(trigger?.automation_trigger_inputs?.map((input) => [input.key, input.value]) ?? [])

  for (const rule of definition.providesSubjectsByInputs ?? []) {
    if (rule.when) {
      const conditionValue = inputValues.get(rule.when.field)
      if (typeof conditionValue !== "string" || !rule.when.values.includes(conditionValue)) continue
    }

    const value = inputValues.get(rule.field)
    if (typeof value !== "string") continue

    for (const subject of rule.values[value] ?? []) subjects.add(subject)
  }

  if (definition.key === "trigger__opportunity_created" && pipelines) {
    const condition = trigger?.condition_group?.conditions.find((candidate) => candidate.field === "pipeline_id")
    const ids = condition?.values ?? (condition?.value ? [condition.value] : [])
    if (ids.length > 0) {
      const selected = pipelines.filter((pipeline) => ids.includes(pipeline.id))
      const householdTypes = new Set(["client", "prospect"])
      if (
        selected.length !== new Set(ids).size ||
        selected.some((pipeline) => pipeline.audience_types.some((type) => !householdTypes.has(type)))
      ) {
        subjects.delete("household")
      }
    }
  }

  return [...subjects]
}
